import { render, staticRenderFns } from "./ungroup.vue?vue&type=template&id=3fccb5a0&"
import script from "./ungroup.vue?vue&type=script&lang=ts&"
export * from "./ungroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports